<template>
    <div class="row">
        <div class="col-md-2 col-md-offset-5" style="text-align: center;">
            <div class="login-panel panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">مرحبا: {{userName}}</h3>
                </div>
                <div class="panel-body">
                  <vue-element-loading size='32' :active='stepID === 4' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <form role="form">
                        <fieldset>
                            <div v-if="stepID !== 5" class="form-group">
                              <label>كود العميل</label>
                              <input v-model='customerId' class='form-control' name='nickname' type='text'>
                            </div>
                            <div v-if="stepID !== 5" class="form-group">
                              <vue-element-loading size='32' :active='stepID === 1' spinner='bar-fade-scale' color='#A4A4A4'/>
                                <button type="submit" class="btn btn-info btn-block" @click.prevent="getCustomer" > عرض </button>
                            </div>
                            <div class='alert alert-danger alert-dismissable' v-if="stepID === 2">
                              <ul>
                                  <li v-for='err in errors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                              </ul>
                            </div>
                            <div v-if="stepID === 3 || stepID === 4" class="form-group">
                              <label>المحمول</label>
                              <input v-model='mobile' class='form-control' name='nickname' type='text'>
                            </div>
                            <div v-if="stepID === 3 || stepID === 4" dir="ltr" style="text-align: center; padding: 5px" class="alert alert-info alert-dismissable" >
                            {{customerData.name}}
                            </div>
                            <div v-if="stepID === 3 || stepID === 4" dir="ltr" style="text-align: left; padding: 5px" class="alert alert-info alert-dismissable" >
                              accuracy: {{location.accuracy}}
                              <br>
                              lat: {{location.lat}}
                              <br>
                              lng: {{location.lng}}
                            </div>

                            <!-- Change this to a button or input when using this as a form -->
                            <div v-if="stepID === 3 || stepID === 4" class="form-group">
                                <button type="submit" class="btn btn-success btn-block" @click.prevent="SaveData" > حفظ </button>
                            </div>
                            <div class='alert alert-success alert-dismissable' v-if="stepID === 5">
                              تم حفظ بيانات العميل بنجاح
                            </div>
                            <div v-if="stepID === 5" class="form-group">
                                <button type="submit" class="btn btn-success btn-block" @click.prevent="newCust()" > عميل جديد </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
            <div>
            </div>
        </div>
    </div>
</template>
<style >
#inner {
display: table;
margin: 0 auto;
border: 1px solid black;
}

#outer {
border: 1px solid red;
width:100%
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'GPS',
  data () {
    return {
      stepID: 0,
      userName: '',
      mobile: null,
      customerData: {},
      customerId: '',
      isLoading: false,
      errors: {},
      location: {}
    }
  },
  created () {
    this.userName = localStorage.getItem('name')
  },
  methods: {
    getCustomer () {
      this.stepID = 1
      axios.post(this.$apiURL + 'get-customer-data', {
        token: localStorage.getItem('token'),
        id: this.customerId
      })
        .then(({ data }) => {
          this.$getLocation()
            .then(coordinates => {
              this.location = coordinates
            })
          this.customerData = data
          this.stepID = 3
          this.errors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.errors = err.response.data.errors
          this.stepID = 2
        })
    },
    SaveData () {
      this.stepID = 4
      axios.post(this.$apiURL + 'saveGps', {
        token: localStorage.getItem('token'),
        customer_id: this.customerData.id,
        mobile: this.mobile,
        accuracy: this.location.accuracy,
        lat: this.location.lat,
        lng: this.location.lng
      })
        .then(({ data }) => {
          this.$getLocation()
            .then(coordinates => {
              this.location = coordinates
            })
          this.customerData = data
          this.stepID = 5
          this.errors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.errors = err.response.data.errors
          this.stepID = 2
        })
    },
    newCust () {
      this.customerId = ''
      this.stepID = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myComponents/GPS.vue